import React from 'react';
import Swiper from 'react-id-swiper';
import ProgressiveImage from 'react-progressive-image';
import blur from '../../assets/blur.jpg';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

class MainSwiper extends React.Component {
  render() {
    const params = {
      lazy: true,
      rebuildOnUpdate: true,
      slidesPerView: 6,
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1145: {
          slidesPerView: 5,
        },
        850: {
          slidesPerView: 4,
        },
        640: {
          slidesPerView: 3,
        },
        475: {
          slidesPerView: 2,
        },
      },
    };

    let slides = this.props.sources.map((el, i) => {
      return (
        <div className="backdrop_container" key={el.id}>
          <Link className="title-link" to={`/person/${el.id}`}>
            <ProgressiveImage src={el.photo} placeholder={blur}>
              {(src, loading) => (
                <img
                  style={{
                    opacity: loading ? 0.5 : 1,
                    filter: loading ? 'blur(5px)' : '',
                    width: loading ? 'auto' : 'auto',
                    height: loading ? '190px' : '190px',
                    borderRadius: loading ? '5px' : '5px',
                    transition: 'opacity 1s ease',
                  }}
                  src={src}
                  alt={el.name}
                />
              )}
            </ProgressiveImage>
          </Link>
          <h3 className="backdrop_container__title">{el.name}</h3>
        </div>
      );
    });

    return (
      <>
        <h3 className="slider__title">Cast</h3>
        <Swiper {...params}>{slides}</Swiper>
        <hr className="swiper-divider" />
      </>
    );
  }
}

export default withRouter(MainSwiper);
